module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp2_6000.466252ce.png";